export const MIN_ZOOM = 0.1;

export const STANDARD_ZOOM = 0.5;

export const MAX_ZOOM = 10;
